<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div v-if="!loading">
                    <div class="p-3">
                        <div class="input-group pb-4">
                            <input type="text" class="form-control" placeholder="Search" aria-label="Search" aria-describedby="basic-addon1" v-model="filter.customerSearchQuery">
                            <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon1">
                                        <i class="fas fa-search"></i>
                                    </span>
                            </div>
                        </div>
                        <div class="pb-4">
                            <label>Provinces</label>
                            <bootstrap-select  :selectOptions="provincesFilter" :selectedOption="filter.provinceId" :elementId="'provinceFilterSelect'"
                                               :returnSelectedOptionText="true"
                                               @changeSelect="onProvinceFilterSelected"></bootstrap-select>
                        </div>
                        <div class="float-right mb-3">
                            <button class="btn btn-primary" @click="onFilterSearchClicked">
                                Search
                            </button>
                        </div>
                        
                    </div>
                </div>
                <GMapMap v-show="!loading"
                         ref="mapRef"
                        :center="map.center"
                        :zoom="map.zoom"
                        style="width: 100%; height: 900px"
                >
                    <GMapMarker
                            key="index"
                            v-for="(location, index) in map.locations"
                            :position="location.position"
                            :clickable="true"
                            @click="openMapMarkInfoWindow(location.id)">
                        <GMapInfoWindow
                                :closeclick="true"
                                @closeclick="openMapMarkInfoWindow(null)"
                                :opened="map.openedMarkerId === location.id">
                            <h6 class="text-center">
                                {{location.title}}
                            </h6>
                            <h6>
                                {{location.street}}
                            </h6>
                            <h6>
                                {{location.suburb}}
                            </h6>
                            <h6>
                                {{location.city}}
                            </h6>
                            <h6>
                                {{location.province}}
                            </h6>
                            <h6>
                                {{location.phoneNumber}}
                            </h6>
                            <h6>
                                {{location.email}}
                            </h6>
                        </GMapInfoWindow>
                    </GMapMarker>
                </GMapMap>
                <loading-spinner :showSpinner="loading"></loading-spinner>
            </div>
        </div>
    </div>
</div>
